<form #form="ngForm">
<div [ngStyle]="style">
        <table [class]="css" style="margin-bottom: 0px">
            <thead>
            <tr>
                <ng-container *ngFor="let c of definition?.columns">
                    <th *ngIf="checkColumnVisibility(c)" [ngStyle]="c.style" >
                        <span *ngIf="c.sortable" [title]="c.description"><a style="cursor: pointer;" (click)="toggleSort(c)">{{c.title}}</a></span>
                        <span *ngIf="!c.sortable" [title]="c.description"><span *ngIf="c.type != columnTypes.Button && c.type != columnTypes.ButtonGroup">{{c.title}}</span></span>
                        <input type="checkbox" *ngIf="c.type == columnTypes.Checkbox"  (change)="toggleValue(c)" [(ngModel)]="c.selected" [name]="c.name"
                        >
                        <span *ngIf="checkSort(c)">
                            <i (click)="toggleSort(c)" [ngClass]="getSortIconClass(c)"></i>
                        </span>
                    </th>
                </ng-container>
            </tr>
            </thead>
                <ng-container *ngIf="!definition?.fixedHeaders">
                    <ng-container *ngTemplateOutlet="bodytemplate">
                    </ng-container>
                </ng-container>
        </table>
        <div *ngIf="definition?.fixedHeaders" [ngStyle]="fixedHeaderStyle">
        <table class="table" style="margin-top:0px" [class]="css">
            <ng-container *ngTemplateOutlet="bodytemplate">
            </ng-container>
        </table>
        </div>

    <ng-template #bodytemplate>
      <tbody>
          <ng-container *ngIf="editMode == editModes.AddNew">
              <ng-container *ngTemplateOutlet="editRowTemplate;context:{$implicit: editedRow}"></ng-container>
          </ng-container>
          <ng-container *ngFor="let d of data, let ix = index">
            <ng-container *ngIf="editMode == editModes.Edit && d[keyField] == editedRow[keyField]">
                <ng-container *ngTemplateOutlet="editRowTemplate;context:{$implicit: editedRow}"></ng-container>
            </ng-container>
            <tr *ngIf="editMode != editModes.Edit || d[keyField] != editedRow[keyField]">
                <ng-container *ngFor="let c of definition.columns">
                        <td *ngIf="checkColumnVisibility(c)" [ngStyle]="c.style">
                                <span *ngIf="c.type == columnTypes.Label">
                                    {{checkLength(getValue(d,c),c,ix) | columnFormat:c.dataType:c.format}}
                                    <a [ngStyle]="c.expandTextData.style" (click)="toggleExpand(c,ix)" 
                                      *ngIf="c.expandTextData && shouldShowExpand(d,c,ix)">{{getExpandText(c,ix)}}</a>
                                </span>
                                <span *ngIf="c.type == columnTypes.Textbox">
                                  <input [type]="c.dataType == dataTypes.Numeric ? 'number' : 'text'" class="form-control"
                                  [name]="ix + '_' + c.name" [(ngModel)]="d[c.field]" (change)="onCellChange(d,c)">
                              </span>
                                <span *ngIf="c.type == columnTypes.Checkbox"><input type="checkbox" [name]="ix + '_' + c.name"
                                  [(ngModel)]="d[c.field]" (change)="onCellChange(d,c)"></span>
                                <span *ngIf="c.type == columnTypes.Button">
                                    <button class="btn btn-default" type="button" [ngClass]="c.buttonCss"
                                    (click)="buttonClicked(d, c)" *ngIf="checkColumnButtonVisibility(d,c, c.name)">
                                        <i *ngIf="c.buttonIcon" [ngClass]="'fa ' + c.buttonIcon" [title]="c.title"></i>
                                        {{c.title}}
                                    </button>
                                </span>
                                <span *ngIf="c.type == columnTypes.ButtonGroup">
                                        <span *ngFor="let b of c.buttons">
                                            <button class="btn btn-default" type="button" [ngClass]="b.css"
                                            (click)="buttonClicked(d, c, b, form)"
                                            *ngIf="checkColumnButtonVisibility(d,c, b.name)" [disabled]="checkColumnGroupDisabledStatus(d, c, b.name)">
                                                    <i *ngIf="b.icon" [ngClass]="'fa ' + b.icon" [title]="b.text"></i>
                                                    <span *ngIf="!b.iconOnly">{{b.text}}</span>
                                            </button>
                                        </span>
                                </span>
                                <span *ngIf="c.type == columnTypes.Custom"><app-customcolumn [row]="d" [column]="c"></app-customcolumn></span>
                                <span *ngIf="c.type == columnTypes.Checkmark">
                                    <span *ngIf="d[c.field]==true" [ngClass]="c.buttonCss || 'fas fa fa-check glyphicon glyphicon-ok'"></span>
                                </span>
                                <span *ngIf="c.type == columnTypes.Link" [title]="c.tooltipField != null ? getValue(d, c, 'tooltipField') : ''">
                                    <a [href]="getValue(d,c,'linkField')" [target]="c.linkTarget">{{getValue(d, c)}}</a> </span>
                                <span *ngIf="c.type == columnTypes.List" [title]="c.tooltipField != null ? getValue(d, c, 'tooltipField') : ''">
                                    {{checkLength(joinListValue(d, c), c,ix)}}
                                    <a [ngStyle]="c.expandTextData.style" (click)="toggleExpand(c,ix)" 
                                      *ngIf="c.expandTextData && shouldShowExpand(d,c,ix)">{{getExpandText(c,ix)}}</a>
                                </span>
                                <span *ngIf="c.type == columnTypes.LinkList" [title]="c.tooltipField != null ? getValue(d, c, 'tooltipField') : ''">
                                  <span style="display: block" *ngFor="let elem of getValue(d,c)">
                                    <a [href]="elem[c.linkField]" [target]="c.linkTarget">{{elem[c.listDisplayField]}}</a>                                    
                                  </span>                                  
                                </span>
                                <span *ngIf="c.type == columnTypes.Image" [title]="c.tooltipField != null ? getValue(d, c, 'tooltipField') : ''">
                                    <img [style]="c.style" [src]="getValue(d,c)"> </span>
                                <span *ngIf="c.type == columnTypes.Password">
                                      {{getValue(d,c) | columnFormat:c.dataType:c.format}}
                                      <button class="ml-2 ms-2 btn" *ngIf="isPassword(c) && c.allowPasswordCopy">
                                        <span class="fas fa-copy" (click)="onPasswordCopy(d[c.field])"></span>
                                      </button>
                                </span>
                            </td>
                </ng-container>

            </tr>
          </ng-container>

        </tbody>
    </ng-template>
    <ng-template #editRowTemplate let-row>
        <tr>
            <ng-container *ngFor="let c of definition?.columns">
                <td *ngIf="checkColumnVisibility(c)" [ngStyle]="c.style">
                        <span *ngIf="c.editable && checkColumnEditorVisibilityStatus(row,c) 
                        && (c.editorType == editorTypes.Textbox || isPassword(c) )">
                                <input
                                  [type]="isPassword(c) ? 'password': 'text'"
                                  [placeholder]="c.title"
                                  [required]="c.required"
                                  [name]="c.name || c.field"
                                  [class.has-error]="editValidation && form.controls[c.name].invalid"
                                  class="form-control input-sm"
                                  [(ngModel)]="row[c.field]"
                                /> 
                        </span>
                        <span *ngIf="c.editable  && checkColumnEditorVisibilityStatus(row,c) && c.editorType == editorTypes.Dropdown">
                            <select
                              [(ngModel)]="row[c.selectedValueField]"
                              class="form-control input-sm"
                              [name]="c.name || c.field"
                              [required]="c.required"
                              [class.has-error]="editValidation && form.controls[c.name].invalid"
                            >
                                <option *ngFor="let o of c.dropdownData" [value]="o[c.valueField]">{{o[c.displayField]}}</option>
                            </select>
                        </span>
                        <span *ngIf="c.editable && checkColumnEditorVisibilityStatus(row,c) && c.editorType == editorTypes.Checkbox">
                            <input type="checkbox" [(ngModel)]="row[c.field]" [name]="c.name || c.field"></span>
                        <span *ngIf="c.type == columnTypes.Button">
                            <button class="btn btn-default" type="button" [ngClass]="c.buttonCss" (click)="buttonClicked(row, c)" *ngIf="checkColumnButtonVisibility(row,c, c.name)">
                                <i *ngIf="c.buttonIcon" [ngClass]="'fa ' + c.buttonIcon"></i>
                                {{c.title}}
                            </button>
                        </span>
                        <span *ngIf="c.editable && checkColumnEditorVisibilityStatus(row,c) && c.editorType == editorTypes.Autocomplete">
                            <div class="input-group" >
                                    <input [(ngModel)]="row[c.field]"
                                    [typeahead]="c.autoCompleteData.data"
                                    (typeaheadOnSelect)="onAutoCompleteSelected(c, $event)"
                                    [typeaheadOptionsLimit]="c.autoCompleteData.optionsLimit"
                                    (typeaheadLoading)="onAutoCompleteLoading(c, $event)"
                                    [typeaheadMinLength]="c.autoCompleteData.minLength"
                                    [typeaheadOptionField]="c.autoCompleteData.optionField"
                                    [class.has-error]="editValidation && form.controls[c.name].invalid"
                                    [placeholder]="c.title"
                                    [name]="c.name || c.field" class="form-control input-sm"
                                    >

                                </div>
                        </span>
                        <span *ngIf="c.type == columnTypes.ButtonGroup">
                                <span *ngFor="let b of c.buttons">
                                    <button class="btn btn-default" type="button" [ngClass]="b.css" (click)="buttonClicked(row, c, b, form)"
                                    *ngIf="checkColumnButtonVisibility(row,c, b.name)" [disabled]="checkColumnGroupDisabledStatus(row, c, b.name)">
                                            <i *ngIf="b.icon" [ngClass]="'fa ' + b.icon"></i>
                                            {{b.text}}
                                    </button>
                                </span>
                        </span>
                        <span *ngIf="c.editable && checkColumnEditorVisibilityStatus(row,c) && c.editorType == editorTypes.MultipleChoiceTagInput">
                            <tag-input [ngModel]="row[c.field]" [onlyFromAutocomplete]="c.multipleSelectionData.autocompleteOnly"
                            [identifyBy]="c.multipleSelectionData.idField"  [displayBy]="c.multipleSelectionData.displayField"
                             [placeholder]="c.multipleSelectionData.placeHolder" [name]="c.name || c.field">
                               <tag-input-dropdown *ngIf="c.multipleSelectionData.autocompleteItems"
                               [autocompleteItems]="c.multipleSelectionData.autocompleteItems"
                               [identifyBy]="c.multipleSelectionData.idField"
                            [displayBy]="c.multipleSelectionData.displayField">
                            </tag-input-dropdown>
                            </tag-input>
                        </span>
                        <span *ngIf="c.editable && checkColumnEditorVisibilityStatus(row,c) && c.editorType == editorTypes.MultipleChoiceCheckboxes">
                            <multiple-checkbox [data]="row[c.field]"></multiple-checkbox>
                        </span>
                        <span *ngIf="(!c.editable || !checkColumnEditorVisibilityStatus(row,c)) && c.type == columnTypes.Label">
                            {{getValue(row, c) | columnFormat:c.dataType:c.format}}
                        </span>
                    </td>
            </ng-container>

        </tr>
    </ng-template>
</div>
</form>
